import styled from 'styled-components';
import { Form as FormikForm } from 'formik';
import { Icon, Styles } from '@gv/triage-components';

const { bodySemibold } = Styles.Font;

export const Text = styled.p`
  ${bodySemibold};
  min-width: 36px;
`;

export const Form = styled(FormikForm)`
  width: 100%;
`;

export const StyledIcon = styled(Icon.Chat)`
  cursor: pointer;
  path {
    fill: #0a51c5;
  }
`;
